import { render, staticRenderFns } from "./InventoryScreen.vue?vue&type=template&id=1b8cfd88&scoped=true"
import script from "./InventoryScreen.vue?vue&type=script&lang=js"
export * from "./InventoryScreen.vue?vue&type=script&lang=js"
import style0 from "./InventoryScreen.vue?vue&type=style&index=0&id=1b8cfd88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8cfd88",
  null
  
)

export default component.exports